<template>
  <div style="height: 100%">
    <SplitContainer2 style="height:100%" layout="horizontal" :split_setting="0.4">
      <template #table1>
        <TableMain name="one table" ref="BOMTable1" :fields="fields1" :title="table_title.title1"
          :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="false" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" :isBusy="isBusy" :table_height_adjust="-6"
          :hb_table_class="'hb_table_bom_relation_class1'" @on_query="on_query" @state_change="state_change"
          :show_toolbar_button="[0, 0, 0, 0, 0]" @tool_invoke="tool_invoke" @current_changed="current_changed" tableref="be642fc550f34575a3a10a40b67bac9f">
          <template #query>
            <el-input clearable size="small" style="width: 300px" placeholder="请输入物料编号、BOM名称（或编号）"
              v-model="SearchText"></el-input>
          </template>
          <template #toolbar>
            <el-button type="info" plain class="ml-2" @click="BomRouteDiff"><i class="iconfont icon-refresh"></i>
              BOM&工艺核对</el-button>
          </template>
        </TableMain>
      </template>
      <template #table2>
        <TableMain ref="BOMTable3" :show_query_container="false" :show_date_picker="false" :fields="fields2"
          :table_height_adjust="10" :title="table_title.title3" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" :show_toolbar="true" :show_toolbar_button="[0, 0, 0, 0, 1]" :pager_count="5"
          :isBusy="isBusy_table3" :loading_width="50" :hb_table_class="'hb_table_bom_relation_class3'"
          :show_toolbar_state="false" tableref="7024ce23a69b4ac498daf696da289524">
          <template #operation>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="SaveBOMItems"
              :label="$t('common.save')" class="ml-2"></QueryButton>
          </template>
        </TableMain>
      </template>
    </SplitContainer2>
  </div>
</template>

<script>
import SplitContainer2 from "../components/container/SplitContainer2"
import TableMain from "../components/table/TableMain"
import * as InventBomController from "../../controllers/sd/InventBomController"
import QueryButton from "../components/base/QueryButton"
export default {
  components: {
    SplitContainer2,
    TableMain,
    QueryButton
  },
  data() {
    return {
      date_picker_label: "",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "BOM",
        title3: "bom_route_relation"
      },
      fields1: _.cloneDeep(InventBomController.fields.default),
      fields2: InventBomController.fields.bom_route_relation,
      SearchText: "",
      isBusy: false,
      current_bom_num: "",

      data: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      InventRouteOptions: [],
      isBusy_table2: false,
      isBusy_table3: false
    }
  },
  created() {
    let _this = this
    let _field = _.find(this.fields2, {
      key: "OprNum",
    })
    _field["_options"] = {
      provider: (v) => {
        return _this.InventRouteOptions
      },
    }

    let f = _.find(this.fields1, { key: "id" })
    delete f.type
  },
  mounted() {
  },
  methods: {
    //#region 查询
    async on_query(set_data) {
      this.SearchText = _.trim(this.SearchText)
      this.data = []
      this.current_bom_num = ""
      this.isBusy = true
      set_data([])
      let p = { SearchText: this.SearchText }

      let _result = await InventBomController.methods.getData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        set_data(_.orderBy(_result[0], ["id"], ["desc"]))
      }
      this.isBusy = false
    },

    async getBomItems(BOMId, isLoading = true) {
      if (isLoading) {
        this.isBusy_table3 = true
        this.$refs.BOMTable3.SetData([])
      }

      let p = { BOMId: BOMId, is_deleted: 0, Active: 1 }
      let _result = await InventBomController.methods.getBomItems(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.$refs.BOMTable3.SetData(_.orderBy(_result[0], ["id"], ["asc"]))
      }
      this.isBusy_table3 = false
    },
    async getInventRouteOptions(ItemId, dataAreaId) {
      let p = { ItemId: ItemId, dataAreaId: dataAreaId }
      let _result = await InventBomController.methods.getInventRouteList(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.orderBy(_result[0], ["OprNum"], ["asc"])
        dt = _.uniqBy(dt, "OprNum")
        this.InventRouteOptions = _.map(dt, (t) => {
          return {
            value: t.OprNum,
            label: t.OprNum + ":" + t.OprId
          }
        })
      }
    },
    //#endregion

    //#region 保存
    createForm() { },
    //#endregion

    //#region 状态切换
    // state_change(data, cb) {

    // },
    //#endregion

    //#region 打印导出
    tool_invoke(data, cb) {

      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: this.$t("table.table_customer"),
          sheet_title: "部件档案",
        }
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data)
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data)
      }
    },
    //#endregion

    async current_changed(old, current) {
      if (_.isNull(current)) {
        this.$refs.BOMTable3.SetData([])
        return
      }
      await this.getInventRouteOptions(current.ItemId, current.dataAreaId)
      this.getBomItems(current.BOMId)
    },
    ///保存bom明细
    async SaveBOMItems(cb) {
      let dt = this.$refs.BOMTable3.my_data
      if (dt.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      //数据验证
      let msg = ""
      _.each(dt, (t) => {
        for (var k in t) {
          if (k.startsWith("_")) {
            delete t[k]
          }
          if (msg == "" && t[k] == "") {
            let m = _.find(this.fields3, { key: k })
            if (m && m.require && m.editable) {
              msg = m.label + "不能为空！"
            }
          }
        }
      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }

      let p = {}
      p.add = _.map(_.filter(_.cloneDeep(dt), { id: "" }), (t) => { delete t.id; return t })
      p.edit = _.filter(_.cloneDeep(dt), (t) => { return t.id != "" })
      let rt = await InventBomController.methods.saveDataBomItems(p)
      if (rt) {
        let current = this.$refs.BOMTable1.GetCurrentItem()
        if (current) {
          await this.getInventRouteOptions(current.ItemId, current.dataAreaId)
          this.getBomItems(current.BOMId, false)
        }

        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true, true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    BomRouteDiff() {
      let selected_items = this.$refs.BOMTable1.GetSelectedItems()
      if (selected_items.length == 0) {
        return
      }
      else if (selected_items.length > 1) {
        this.msgToasts("目前核对功能只能针对一个版本进行！", "info")
        return
      }
      this.$emit("goBomRouteDiff", { dataAreaId: selected_items[0].dataAreaId, ItemId: selected_items[0].ItemId })
    }
  },
}
</script>
<style>
.hb_table_bom_relation_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 75rem;
}

.hb_table_bom_relation_class3 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 130rem;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
